import { Button, ButtonProps } from './button';

type SubmitButtonProps = Readonly<
  Pick<ButtonProps, 'loading' | 'children' | 'disabled' | 'fullWidth' | 'sx'>
>;

export function SubmitButton(props: SubmitButtonProps): React.JSX.Element {
  return <Button type="submit" variant="contained" {...props} />;
}
